module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk og engelsk_sekundærlogo_pos(svart).f2036987.svg";